var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 24 12 0 0 24zm-13.286-3.692v-2.77h2.572v2.77zm0-4.616h2.572v-5.538h-2.572z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "warning_svg__mask0_383_15599",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24 24 12 0 0 24zm-13.286-3.692v-2.77h2.572v2.77zm0-4.616h2.572v-5.538h-2.572z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#warning_svg__mask0_383_15599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10h3v6h-3zM10.5 17.5h3v3h-3z"
  })));
};
export default SvgWarning;